var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ShouldDisplay)?_c('div',{staticClass:"notificationBubble",class:{ 'blockDisplay': _vm.displayBlock }},[_vm._v(_vm._s(_vm.count))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }